import { IntlMessageFormat, type PrimitiveType } from 'intl-messageformat';
import { intlLocale, type Locale } from './locale';

export type MessageValues = Record<string, PrimitiveType>;

const cache = new Map<string, IntlMessageFormat>();

/** Formats an ICU message, caching the compiled form per locale and source string. */
export function formatMessage(locale: Locale, source: string, values?: MessageValues): string {
  const key = `${locale}\u0000${source}`;
  let compiled = cache.get(key);
  if (!compiled) {
    compiled = new IntlMessageFormat(source, intlLocale(locale));
    cache.set(key, compiled);
  }
  const out = compiled.format(values);
  return Array.isArray(out) ? out.join('') : String(out);
}
